// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.1 4.5H8.1V6.9C8.1 7.73 7.43 8.4 6.6 8.4H5.6C4.77 8.4 4.1 7.73 4.1 6.9V4.5Z',
  'M4.9 4.5V2.35C4.9 1.88 5.28 1.5 5.75 1.5H6.45C6.92 1.5 7.3 1.88 7.3 2.35V4.5',
  'M8.1 5.7H9.3C11.73 5.7 13.7 7.67 13.7 10.1C13.7 12.53 11.73 14.5 9.3 14.5',
  'M5.4 10.3H6.8M3.9 12.3H9.4M2 14.5H14.5',
];
